import { useTranslation } from 'react-i18next'
import { ConfirmModal, Title } from '@/ui'
import styles from './ConfirmContractModal.module.scss'
import React from 'react'

export const ConfirmContractModal = ({ onProcess, onCancel, isLoading }) => {
	const { t } = useTranslation()

	return (
		<ConfirmModal
			onProcess={onProcess}
			onCancel={onCancel}
			cancelButtonTitle={'no_cancel'}
			processButtonTitle={t('sign_and_send')}
			hideBackButton
			priority={2}
			isLoading={isLoading}
		>
			<div className={styles.content}>
				<Title>{t('contracts_tab.confirm_contract.title')}</Title>
				<p>{t('contracts_tab.confirm_contract.are_you_sure_confirm')}</p>
			</div>
		</ConfirmModal>
	)
}
